import { callBackendApi } from "@/utils/common";
import { BiSitemap } from "react-icons/bi";
import Header from "@/components/sitemap-html/header";
import Link from "next/link";

const SitemapHtml = (props) => {
    const { allPostsData } = props;

    return (
        <>
            <Header />
            <div className="container">
                <div className="p-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb m-0">
                            <li className="breadcrumb-item fs-5"><Link href="/sitemap-html">
                                <a className="mds-text-primary"><BiSitemap /> Sitemap</a>
                            </Link></li>
                            <li className="breadcrumb-item active fs-5" aria-current="page">Posts</li>
                        </ol>
                    </nav>
                </div>
                <div className="card bg-transparent border-0  mb-5">
                    <ul className="list-group list-group-flush mds-list-group-flush">
                        {allPostsData.map((_, index) =>
                            <li className="list-group-item">
                                <Link
                                    
                                    href={`/community/posts/${_.slug}`}
                                >
                                    <a className="text-capitalize mds-text-primary">
                                    {_.title}
                                    </a>
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </>

    )
}

export const getServerSideProps = async (context) => {

    const allPostsData = await callBackendApi({
        method: "get",
        url: "/community/posts",
        params: {
            select: "slug title"
        }
    }).then(response => response.data.data);


    return {
        props: {
            allPostsData
        },
    };
};

export default SitemapHtml;

